function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M2.87 38.4h49.46c1.59-.09 2.87-1.42 2.87-3.03V3.03c0-1.66-1.35-3.02-3.01-3.03H3.01A3.037 3.037 0 0 0 0 3.03v32.33c0 1.62 1.28 2.95 2.87 3.04z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M23.74 23.03V38.4h7.68V23.03H55.2v-7.68H31.42V0h-7.68v15.35H0v7.68h23.74z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M33.98 12.43V0h18.23c1.26.02 2.34.81 2.78 1.92L33.98 12.43zM33.98 25.97V38.4h18.35c1.21-.07 2.23-.85 2.66-1.92L33.98 25.97zM21.18 25.97V38.4H2.87a3.043 3.043 0 0 1-2.66-1.94l20.97-10.49zM21.18 12.43V0H2.99A3.04 3.04 0 0 0 .21 1.94l20.97 10.49zM0 12.8h7.65L0 8.97v3.83zM55.2 12.8h-7.69l7.69-3.85v3.85zM55.2 25.6h-7.69l7.69 3.85V25.6zM0 25.6h7.65L0 29.43V25.6z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M55.2 3.25 36.15 12.8h4.26L55.2 5.4V3.25zM19.01 25.6h-4.26L0 32.98v2.15l19.05-9.53h-.04zM10.52 12.81h4.26L0 5.41v2.14l10.52 5.26zM44.63 25.59h-4.26l14.83 7.43v-2.14l-10.57-5.29z"
});
const SvgIconEnFlag = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "9 0 38 38",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEnFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-en-flag.c2f6f3da.svg";
export { ForwardRef as ReactComponent };